import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  GetSystemSettings,
  UpdateSystemSettings
} from "../../../actions/SystemSettingsActions";
const SystemSettings = () => {
  const dispatch = useDispatch();
  const systemSettingsInfo = useSelector((state) => state.systemSettingsInfo.value);
  const loginInfo = useSelector((state) => state.loginInfo.value);
  const [forceRejectReason, updateForceRejectReason] = useState(true);
  const [multipleRolesCombinedBehavior, updateMultipleRolesCombinedBehavior] = useState("OR");
  const [loginToken, updateLoginToken] = useState("");
  const [trinFormsUrl, updateTrinFormsUrl] = useState("");
  const [useRecommendedRolePermissions, updateUseRecommendedRolePermissions] = useState(true);
  const [displayAboutRecommendedRolePermissions, updateDisplayAboutRecommendedRolePermissions] = useState(false);
  const [displayPremiumAIPopup, updateDisplayPremiumAIPopup] = useState(true);
  useEffect(() => {
    if (!systemSettingsInfo.loaded) {
      GetSystemSettings(dispatch);
    } else {
      updateForceRejectReason(systemSettingsInfo.forceRejectReason);
      updateMultipleRolesCombinedBehavior(systemSettingsInfo.multipleRolesCombinedBehavior);
      updateLoginToken(systemSettingsInfo.loginToken);
      updateTrinFormsUrl(systemSettingsInfo.trinFormsUrl);
      updateUseRecommendedRolePermissions(systemSettingsInfo.useRecommendedRolePermissions);
      updateDisplayPremiumAIPopup(systemSettingsInfo.displayPremiumAIPopup);
    }
  }, [systemSettingsInfo, loginInfo]);
  const toggleRejectReason = () => {
    updateForceRejectReason(!forceRejectReason);
  };
  const toggleDisplayPremiumAIPopup = () => {
    updateDisplayPremiumAIPopup(!displayPremiumAIPopup);
  };
  const toggleUseRecommendedRolePermissions = () => {
    updateUseRecommendedRolePermissions(!useRecommendedRolePermissions);
  };
  const onChangeMultipleRolesCombinedBehavior = () => {
    if (multipleRolesCombinedBehavior === "OR") {
      updateMultipleRolesCombinedBehavior("AND");
    } else {
      updateMultipleRolesCombinedBehavior("OR");
    }
  };
  const onChangeLoginToken = (e) => {
    updateLoginToken(e.target.value);
  };
  const onChangeTrinFormsUrl = (e) => {
    updateTrinFormsUrl(e.target.value);
  };
  const saveSystemSettings = () => {
    let currentSettings = {
      forceRejectReason,
      multipleRolesCombinedBehavior,
      loginToken,
      trinFormsUrl,
      useRecommendedRolePermissions,
      displayPremiumAIPopup
    };
    UpdateSystemSettings(currentSettings);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "container" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { maxWidth: "60%", margin: "12px" },
      id: "intakeInfo",
      className: "card"
    },
    /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-gear" }), " System Settings"),
    /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "rejectDupeswitch" }, "Require a note on rejection"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "form-check-input",
        type: "checkbox",
        checked: forceRejectReason,
        onChange: toggleRejectReason,
        id: "rejectDupeswitch"
      }
    )), loginInfo.trinDocsLicenseLevel == 5 && /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Use recommended (2026+) role permission model", " ", /* @__PURE__ */ React.createElement(
      "i",
      {
        className: "fa-solid fa-circle-info",
        onClick: () => updateDisplayAboutRecommendedRolePermissions(!displayAboutRecommendedRolePermissions)
      }
    )), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "form-check-input",
        type: "checkbox",
        checked: useRecommendedRolePermissions,
        onChange: toggleUseRecommendedRolePermissions,
        id: "useRecommendedRolePerimissionsSwitch"
      }
    )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "multipleRolesCombinedBehavior" }, "Multiple Roles Combined Behavior"), /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "form-select",
        "aria-label": "Multiple Roles Combined Behavior",
        value: multipleRolesCombinedBehavior,
        onChange: onChangeMultipleRolesCombinedBehavior
      },
      /* @__PURE__ */ React.createElement("option", { value: "OR" }, "OR"),
      /* @__PURE__ */ React.createElement("option", { value: "AND" }, "AND")
    )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "multipleRolesCombinedBehavior" }, "TrinForms URL"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        className: "form-control",
        "aria-label": "TrinForms Base Url",
        value: trinFormsUrl,
        onChange: onChangeTrinFormsUrl
      }
    )), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn btn-success btn-sm mt-3",
        onClick: saveSystemSettings
      },
      "Save"
    ))
  ), displayAboutRecommendedRolePermissions && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "td-dialogue card",
      style: { height: "280px", width: "500px" }
    },
    /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "About Recommended Role Permissions", /* @__PURE__ */ React.createElement(
      "button",
      {
        onClick: () => updateDisplayAboutRecommendedRolePermissions(!displayAboutRecommendedRolePermissions),
        className: "btn-close"
      }
    )),
    /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("strong", null, "Legacy"), " - Supports clients implemented prior to 2026. New clients should use the updated model.", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("strong", null, "Recommended (2026+)"), " - Our current role permission model and the default choice for all clients 2026 and beyond.", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null), "Go to Development ticket TD6-1938 for more information of the details of this change")))))
  )));
};
export default SystemSettings;
